import { createFileRoute } from "@tanstack/react-router";
import { FiliaisPage } from "@/pages/FiliaisPage";

export const Route = createFileRoute("/filiais/")({
  head: () => ({ meta: [{ title: "Filiais — AXIS Comprovantes" }] }),
  component: () => <FiliaisPage />,
});
